const sapUnpaidInvoicesTableColumn = [
    {
        Header: "S.no",
        id: "s_no",
        width: "75",
    },
    {
        Header: "Sales Employee",
        accessor: "sales_employee",
    },
    {
        Header: "BP Code",
        accessor: "bp_code",
    },
    {
        Header: "BP Name",
        accessor: "bp_name",
        width: "500",
    },
    {
        Header: "Group",
        accessor: "group",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "Doc No",
        accessor: "doc_number",
    },
    {
        Header: "Posting Date",
        accessor: "posting_date",
    },
    {
        Header: "Due Date",
        accessor: "due_date",
    },
    {
        Header: "Document Date",
        accessor: "document_date",
    },
    {
        Header: "BP Ref No",
        accessor: "bp_ref_number",
    },
    {
        Header: "Balance Due",
        accessor: "balance_due",
        Cell: ({ value }) =>
            Number(value || 0).toLocaleString("en-PH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }),
    },
];

const FooterRow = ({ value }) => {
    return (
        <tr>
            <td colSpan={11} className="fw-bold">
                Grand Total
            </td>
            <td className="text-start fw-bold">
                {Number(value || 0).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}
            </td>
        </tr>
    );
};

export { sapUnpaidInvoicesTableColumn, FooterRow };
